import axios from '@/api/axiosInstance';

export default async function getTeachersClasses({
  teacherId,
  archived,
  includeAll,
  language,
}) {
  const response = await axios({
    url: `${process.env.NEXT_PUBLIC_API}/teachers/${teacherId}/classes`,
    params: {
      archived,
      includeAll,
      language,
    },
  });

  return response.data;
}
